import type { ReactNode } from "react";

type Props = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  align?: "left" | "center";
};

export default function SectionHeading({ title, subtitle, action, align = "left" }: Props) {
  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-end gap-3 sm:gap-6 ${
        align === "center" ? "sm:justify-center text-center sm:text-left" : "sm:justify-between"
      }`}
    >
      <div className={align === "center" ? "sm:text-center" : ""}>
        <div className={`flex items-center gap-3 ${align === "center" ? "sm:justify-center" : ""}`}>
          <span className="w-1.5 h-6 rounded-full bg-accent-500" />
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        </div>
        {subtitle && <p className="mt-2.5 text-sm text-secondary-500 max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div className="flex items-center gap-2 shrink-0">{action}</div>}
    </div>
  );
}